// src/components/common/ListAddButton.js
import React from "react";
import { Plus } from "lucide-react";

function ListAddButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-14 h-14 rounded-full bg-[rgb(0,224,198)] shadow-lg flex items-center justify-center hover:scale-105 transition-transform active:scale-95"
    >
      <Plus className="w-8 h-8 text-white" strokeWidth={3} />
    </button>
  );
}

export default ListAddButton;
